import {
  GetBusinessInfoResponse,
  MyBusiness,
} from "@1games-ru/region-shared/dist/backend/requests/business";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import useAppSelector from "@/core/helpers/useAppSelector";
import Pagination from "@/shared/ui/Pagination";
import DeviceTabContentWrapper from "@/shared/widgets/DeviceTabContentWrapper";
import { purchaseHistoryData } from "@/domains/business/slice";
import useGetHistory from "@/domains/business/hooks/useGetHistory";
import PurchaseHistoryLog from "@/domains/business/components/purchaseHistory/purchaseHistoryLog";

type Props = {
  info: MyBusiness | GetBusinessInfoResponse;
  onClose: () => void;
};

export default function BusinessPurchaseHistoryContainer({ info, onClose }: Props) {
  const { t } = useTranslation("business");
  const data = useAppSelector(purchaseHistoryData);

  const [currentPage, setCurrentPage] = useState(1);

  const { isLoading } = useGetHistory(info?.id, currentPage, 14);

  const footer =
    data?.totalCount && data.totalCount > 0 ? (
      <div className="relative flex pt-5">
        <div className="absolute z-2 -top-5 left-0 w-full h-5 bg-gradient-to-t from-dark-900 to-transparent pointer-events-none" />
        <div className="absolute z-2 -top-3 left-0 w-full h-3 bg-gradient-to-t from-dark-900 to-transparent pointer-events-none" />
        <Pagination
          currentPage={data.currentPage}
          totalPages={data.totalPages}
          setCurrentPage={setCurrentPage}
          className="ml-auto"
        />
      </div>
    ) : null;

  return (
    <DeviceTabContentWrapper
      header={t("business.purchaseHistory.title")}
      footer={footer}
      onClose={onClose}
      className="pb-4"
      isLoading={isLoading}
    >
      {data &&
        data.orders.map((item, idx) => {
          const isOdd = idx % 2 !== 0;
          return (
            <PurchaseHistoryLog
              key={item.id}
              isOdd={isOdd}
              list={item.products}
              price={item.price}
            />
          );
        })}
    </DeviceTabContentWrapper>
  );
}
